export { default as LayoutAnonymous } from './LayoutAnonymous';
